(function () {
  'use strict';

  /* ── Config ── */
  var MAX_PICKS   = window._pbVoteMaxPicks || 3;
  var WEEK_KEY    = 'pb_vote_' + getWeekId();
  var KV_KEY      = window._pbKlaviyoKey  || '';
  var KV_LIST_ID  = window._pbKlaviyoListId || '';
  var WORKER_URL   = 'https://pb-vote-worker.developer-mozigoltd.workers.dev';
  var PENDING_KEY  = 'pb_pending_votes';
  var EMAIL_KEY    = 'pb_email';

  /* ── State ── */
  var picks            = [];
  var patterns         = [];
  var prizes           = [];
  var activePickIdx    = 0;
  var wheelDeg         = 0;
  var hasSpun          = false;
  var wheelInitialized = false;
  var submittedEmail   = '';
  var submittedPicks   = [];

  /* ── Helpers ── */
  function getWeekId() {
    var d = new Date();
    var start = new Date(d.getFullYear(), 0, 1);
    var week = Math.ceil((((d - start) / 86400000) + start.getDay() + 1) / 7);
    return d.getFullYear() + '_w' + week;
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function parseJSON(id) {
    try { return JSON.parse(qs('#' + id).textContent); } catch (_) { return []; }
  }

  function getISOWeek() {
    var d   = new Date();
    var day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    var week = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return d.getUTCFullYear() + '-W' + String(week).padStart(2, '0');
  }

  function applyVotePercentages(percentages) {
    qsa('.pb-pattern-card').forEach(function (card) {
      var id  = card.dataset.patternId;
      var pct = percentages[id] !== undefined ? percentages[id] : 0;

      card.dataset.votePct = pct;
      var label = qs('.pb-pct-label', card);
      var bar   = qs('.pb-pct-bar', card);
      var badge = card.querySelector('.absolute.bottom-2\\.5');
      if (label) label.textContent = pct + '%';
      if (bar)   bar.style.width   = pct + '%';
      if (badge) badge.style.display = pct >= 40 ? '' : 'none';
    });
  }

  function loadCurrentPercentages() {
    fetch(WORKER_URL + '/votes?week=' + encodeURIComponent(getISOWeek()))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.ok && data.percentages) applyVotePercentages(data.percentages);
      })
      .catch(function (err) {
        console.warn('PB Vote Worker: không tải được % hiện tại', err);
      });
  }

  function sendVoteToWorker(patternIds) {
    var week = getISOWeek();
    patternIds.forEach(function (id) {
      fetch(WORKER_URL + '/vote', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ patternId: id, week: week }),
      }).then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.ok && data.percentages) applyVotePercentages(data.percentages);
        })
        .catch(function (err) {
          console.warn('PB Vote Worker: gửi vote thất bại', err);
          /* Lỗi không ảnh hưởng UX — vote Klaviyo vẫn chạy bình thường */
        });
    });
  }

  /* ── Boot ── */
  function init() {
    patterns = parseJSON('pb-patterns-data');
    prizes   = parseJSON('pb-prizes-data');

    initPatternGrid();
    updatePicksLabel();
    initGalleryNav();
    initSubmitForm();
    checkAlreadyVoted();
    loadCurrentPercentages();
  }

  /* ────────────────────────────────────────────
     PATTERN GRID
  ──────────────────────────────────────────── */
  function initPatternGrid() {
    var cards   = qsa('.pb-pattern-card');
    var clearBtn = qs('#pb-clear-btn');

    cards.forEach(function (card) {
      card.addEventListener('click', function () { togglePick(card, cards); });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); togglePick(card, cards); }
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        picks = [];
        cards.forEach(function (c) { setCardSelected(c, false); });
        updateDimState(cards);
        updatePicksLabel();
        renderGallery();
      });
    }
  }

  function togglePick(card, allCards) {
    var id  = card.dataset.patternId;
    var idx = picks.indexOf(id);

    if (idx > -1) {
      picks.splice(idx, 1);
      setCardSelected(card, false);
    } else {
      if (picks.length >= MAX_PICKS) return;
      picks.push(id);
      setCardSelected(card, true);
    }

    updateDimState(allCards);
    updatePicksLabel();
    renderGallery();
    savePendingVotes();
  }

  function setCardSelected(card, on) {
    var badge = qs('.pb-check-badge', card);
    var led   = qs('.pb-led-bottom', card);
    card.classList.toggle('is-selected', on);
    card.setAttribute('aria-checked', on ? 'true' : 'false');
    if (badge) { badge.style.display = on ? 'flex' : 'none'; }
    if (led)   { led.classList.toggle('hidden', !on); }
  }

  function updateDimState(cards) {
    var atMax    = picks.length >= MAX_PICKS;
    var clearBtn = qs('#pb-clear-btn');
    cards.forEach(function (c) {
      var selected = picks.indexOf(c.dataset.patternId) > -1;
      c.classList.toggle('is-dimmed', atMax && !selected);
    });
    if (clearBtn) clearBtn.classList.toggle('hidden', picks.length === 0);
  }

  function savePendingVotes() {
    var pending = picks.map(function (id) {
      var p = patterns.find(function (x) { return String(x.id) === id; });
      return p ? { collectionId: String(p.id), collectionHandle: p.handle || '', collectionName: p.name || '' } : null;
    }).filter(Boolean);
    try { localStorage.setItem(PENDING_KEY, JSON.stringify(pending)); } catch (_) {}
  }

  function getPendingVotes() {
    try {
      var raw = localStorage.getItem(PENDING_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (_) { return []; }
  }

  function getVoteItemsToSend() {
    var fromPicks = picks.map(function (id) {
      var p = patterns.find(function (x) { return String(x.id) === id; });
      return p ? { collectionId: String(p.id), collectionHandle: p.handle || '', collectionName: p.name || '' } : null;
    }).filter(Boolean);

    var seen = {};
    fromPicks.forEach(function (item) { seen[item.collectionId] = true; });
    getPendingVotes().forEach(function (item) {
      if (!seen[item.collectionId]) {
        fromPicks.push(item);
        seen[item.collectionId] = true;
      }
    });
    return fromPicks;
  }

  function updatePicksLabel() {
    var el  = qs('#pb-picks-label');
    if (!el) return;
    var rem = MAX_PICKS - picks.length;
    el.textContent = rem === 0
      ? 'All picks used!'
      : rem + ' pick' + (rem !== 1 ? 's' : '') + ' remaining';
  }

  /* ────────────────────────────────────────────
     GALLERY
  ──────────────────────────────────────────── */
  function initGalleryNav() {
    var prev = qs('#pb-gallery-prev');
    var next = qs('#pb-gallery-next');

    function scrollTrack(dir) {
      var track = qs('#pb-gallery-track');
      if (!track) return;
      var card = track.querySelector('figure');
      var step = card ? card.offsetWidth + 14 : 280;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollTrack(-1); });
    if (next) next.addEventListener('click', function () { scrollTrack(1); });
  }

  function renderGallery() {
    var section = qs('#pb-gallery-section');
    if (!section) return;

    if (picks.length === 0) {
      section.classList.add('hidden');
      return;
    }
    section.classList.remove('hidden');

    if (activePickIdx >= picks.length) activePickIdx = 0;
    var activeId = picks[activePickIdx];
    var pat = patterns.find(function (p) { return String(p.id) === activeId; }) || {};

    var eyebrow = qs('#pb-gallery-eyebrow');
    var title   = qs('#pb-gallery-title');
    var desc    = qs('#pb-gallery-desc');
    var track   = qs('#pb-gallery-track');
    var tabs    = qs('#pb-gallery-tabs');

    if (eyebrow) eyebrow.textContent = 'Your picks · ' + picks.length;
    if (title)   title.textContent   = pat.name || '';
    if (desc)    desc.textContent    = pat.blurb || '';

    /* Tabs */
    if (tabs) {
      if (picks.length > 1) {
        tabs.innerHTML = '';
        tabs.style.display = 'flex';
        picks.forEach(function (id, i) {
          var p   = patterns.find(function (x) { return String(x.id) === id; }) || {};
          var btn = document.createElement('button');
          btn.textContent = p.name || 'Pattern';
          var active = i === activePickIdx;
          btn.style.cssText = [
            'border-radius:9999px',
            'padding:7px 16px',
            'font-size:12.5px',
            'font-weight:700',
            'cursor:pointer',
            'border:1px solid ' + (active ? '#6E5A9E' : '#E0D9E6'),
            'background:'       + (active ? '#6E5A9E' : '#FFFFFF'),
            'color:'            + (active ? '#FFFFFF' : '#322A45'),
            'transition:background .2s,color .2s,border-color .2s'
          ].join(';');
          btn.addEventListener('click', function () {
            activePickIdx = i;
            renderGallery();
          });
          tabs.appendChild(btn);
        });
      } else {
        tabs.style.display = 'none';
      }
    }

    /* Image track — show products from the picked collection */
    if (track) {
      track.innerHTML = '';
      var items = (pat.products && pat.products.length > 0)
        ? pat.products
        : (pat.cover ? [{ image: pat.cover, title: pat.name || '' }] : []);

      if (items.length > 0) {
        items.forEach(function (prod) {
          var fig  = document.createElement('figure');
          fig.style.cssText = 'flex:none;margin:0;width:min(55vw,260px);scroll-snap-align:start';
          var wrap = document.createElement('div');
          wrap.style.cssText = 'border-radius:16px;overflow:hidden;background:#EFEAF6;aspect-ratio:4/5';
          if (prod.image) {
            var img = document.createElement('img');
            img.src = prod.image;
            img.alt = prod.title || '';
            img.loading = 'lazy';
            img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';
            wrap.appendChild(img);
          } else {
            wrap.style.cssText += ';display:flex;align-items:center;justify-content:center;color:#8D82A0;font-size:13px';
            wrap.textContent = 'No image';
          }
          if (prod.title) {
            var cap = document.createElement('figcaption');
            cap.style.cssText = 'margin-top:8px;font-size:12px;font-weight:700;color:#322A45;text-align:center;padding:0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis';
            cap.textContent = prod.title;
            fig.appendChild(wrap);
            fig.appendChild(cap);
          } else {
            fig.appendChild(wrap);
          }
          track.appendChild(fig);
        });
      } else {
        var placeholder = document.createElement('div');
        placeholder.style.cssText = 'flex:none;width:min(60vw,260px);aspect-ratio:4/5;border-radius:16px;background:#EFEAF6;display:flex;align-items:center;justify-content:center;color:#8D82A0;font-size:13px';
        placeholder.textContent = 'No products';
        track.appendChild(placeholder);
      }
    }
  }

  /* ────────────────────────────────────────────
     SUBMIT FORM
  ──────────────────────────────────────────── */
  function checkAlreadyVoted() {
    try {
      var savedEmail = localStorage.getItem(EMAIL_KEY);
      if (savedEmail) {
        var emailEl = qs('#pb-email-input');
        if (emailEl && !emailEl.value) emailEl.value = savedEmail;
      }
    } catch (_) {}
  }

  function initSubmitForm() {
    var btn      = qs('#pb-submit-btn');
    var emailEl  = qs('#pb-email-input');
    var hintEl   = qs('#pb-cta-hint');
    var confirmEl = qs('#pb-vote-confirm');
    var ctaWrap  = qs('#pb-cta-wrap');
    var wheelWrap = qs('#pb-wheel-wrap');

    if (!btn) return;

    btn.addEventListener('click', function () {
      var email = emailEl ? emailEl.value.trim() : '';

      /* Validate */
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (emailEl) {
          emailEl.style.borderColor = '#FF6F61';
          emailEl.focus();
        }
        if (hintEl) hintEl.textContent = 'Please enter a valid email address.';
        return;
      }

      if (emailEl) emailEl.style.borderColor = '';

      if (picks.length === 0) {
        if (hintEl) hintEl.textContent = 'Please select at least one pattern above first.';
        /* Scroll to grid */
        var grid = qs('#pb-pattern-grid');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      /* ── Klaviyo ── */
      submittedEmail = email;
      submittedPicks = picks.map(function (id) {
        var p = patterns.find(function (x) { return String(x.id) === id; });
        return p ? p.name : id;
      });

      var optIn = !!(qs('#pb-opt-in') && qs('#pb-opt-in').checked);

      try { localStorage.setItem(EMAIL_KEY, email); } catch (_) {}

      var voteItems = getVoteItemsToSend();
      sendVoteToWorker(picks);
      kvSendVoteEvents(email, voteItems);
      try { localStorage.removeItem(PENDING_KEY); } catch (_) {}

      if (optIn && KV_LIST_ID) {
        kvSubscribe(email);
      }

      /* Show confirmation */
      var pickNames = submittedPicks.join(', ');

      if (confirmEl) {
        confirmEl.textContent = '✓ Vote counted for: ' + pickNames;
        confirmEl.classList.remove('hidden');
      }

      /* Swap CTA → Wheel */
      if (ctaWrap)  ctaWrap.classList.add('hidden');
      if (wheelWrap) {
        wheelWrap.classList.remove('hidden');
        wheelWrap.style.display = 'flex';
        /* Init wheel after layout paint */
        requestAnimationFrame(function () {
          if (!wheelInitialized) {
            initWheel();
            wheelInitialized = true;
          }
        });
      }

      /* Wire spin button */
      var spinBtn = qs('#pb-spin-btn');
      if (spinBtn && !spinBtn._pbBound) {
        spinBtn._pbBound = true;
        spinBtn.addEventListener('click', function () {
          if (hasSpun || prizes.length === 0) return;
          var targetIdx = weightedRandom(prizes);
          spinWheel(targetIdx);
        });
      }

      /* TODO: Klaviyo integration
         klaviyo.push(['track', 'Pattern Voted', {
           patterns: picks,
           week: getWeekId(),
           $email: email,
           optIn: document.getElementById('pb-opt-in').checked
         }]);
      */
    });
  }

  /* ────────────────────────────────────────────
     WEIGHTED RANDOM
  ──────────────────────────────────────────── */
  function weightedRandom(items) {
    var total = items.reduce(function (sum, p) { return sum + (p.weight || 1); }, 0);
    var rand  = Math.random() * total;
    var cum   = 0;
    for (var i = 0; i < items.length; i++) {
      cum += (items[i].weight || 1);
      if (rand < cum) return i;
    }
    return items.length - 1;
  }

  /* ────────────────────────────────────────────
     SPIN WHEEL (Canvas)
  ──────────────────────────────────────────── */
  function initWheel() {
    drawWheelAt(0);
  }

  function drawWheelAt(deg) {
    var canvas = qs('#pb-wheel-canvas');
    if (!canvas || prizes.length === 0) return;

    var dpr  = window.devicePixelRatio || 1;
    var disp = canvas.offsetWidth || 300;

    if (canvas.width !== disp * dpr || canvas.height !== disp * dpr) {
      canvas.width  = disp * dpr;
      canvas.height = disp * dpr;
    }

    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    var cx = canvas.width  / 2;
    var cy = canvas.height / 2;
    var r  = Math.min(cx, cy) - dpr;
    var n  = prizes.length;
    var arc = (2 * Math.PI) / n;
    var rotRad = ((deg - 90) * Math.PI) / 180;

    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(rotRad);

    prizes.forEach(function (prize, i) {
      var start = arc * i;
      var end   = start + arc;

      /* Segment fill */
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.arc(0, 0, r, start, end);
      ctx.closePath();
      ctx.fillStyle = prize.color || '#6E5A9E';
      ctx.fill();

      /* Segment divider */
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(r * Math.cos(start), r * Math.sin(start));
      ctx.strokeStyle = 'rgba(255,255,255,0.25)';
      ctx.lineWidth = dpr;
      ctx.stroke();

      /* Label */
      ctx.save();
      ctx.rotate(start + arc / 2);
      ctx.textAlign    = 'right';
      ctx.fillStyle    = prize.textColor || '#FFFFFF';
      ctx.font         = 'bold ' + Math.round(9 * dpr) + 'px Figtree, sans-serif';
      var lines = (prize.short || '').split(' ');
      var lh    = Math.round(12 * dpr);
      lines.forEach(function (line, li) {
        ctx.fillText(line, r - Math.round(12 * dpr), (li - (lines.length - 1) / 2) * lh + Math.round(3 * dpr));
      });
      ctx.restore();
    });

    /* Outer ring */
    ctx.beginPath();
    ctx.arc(0, 0, r, 0, 2 * Math.PI);
    ctx.strokeStyle = 'rgba(255,255,255,0.18)';
    ctx.lineWidth = 2 * dpr;
    ctx.stroke();

    ctx.restore();
  }

  function spinWheel(targetIdx) {
    if (hasSpun) return;
    hasSpun = true;

    var spinBtn = qs('#pb-spin-btn');
    if (spinBtn) { spinBtn.disabled = true; spinBtn.textContent = 'Spinning…'; }

    var n        = prizes.length;
    var arcDeg   = 360 / n;
    /* Center of target segment should land at top (0deg) after rotation */
    var targetCenter = targetIdx * arcDeg + arcDeg / 2;
    var normalised   = (360 - targetCenter) % 360;
    var extra        = 5 * 360;
    var finalDeg     = wheelDeg + extra + ((normalised - wheelDeg % 360) + 360) % 360;

    var startDeg  = wheelDeg;
    var duration  = 4800;
    var startTime = null;

    function easeOut(t) { return 1 - Math.pow(1 - t, 3.5); }

    function frame(ts) {
      if (!startTime) startTime = ts;
      var elapsed  = ts - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var current  = startDeg + (finalDeg - startDeg) * easeOut(progress);
      drawWheelAt(current);
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        wheelDeg = finalDeg % 360;
        setTimeout(function () { showPrizeModal(prizes[targetIdx]); }, 450);
      }
    }

    requestAnimationFrame(frame);
  }

  /* ────────────────────────────────────────────
     PRIZE MODAL
  ──────────────────────────────────────────── */
  function showPrizeModal(prize) {
    var modal         = qs('#pb-prize-modal');
    var shortEl       = qs('#pb-prize-short');
    var titleEl       = qs('#pb-prize-title');
    var descEl        = qs('#pb-prize-desc');
    var codeWrap      = qs('#pb-prize-code-wrap');
    var codeEl        = qs('#pb-prize-code');
    var copyBtn       = qs('#pb-copy-code');
    var finePrint     = qs('#pb-prize-fine-print');
    var finePrintList = qs('#pb-fine-print-list');
    var emailNote     = qs('#pb-prize-email-note');
    var closeBtn      = qs('#pb-close-modal');
    var ctaBtn        = qs('#pb-prize-cta');

    if (!modal || !prize) return;

    /* ── Klaviyo: Prize Won ── */
    kvTrack('Prize Won', {
      week:       getWeekId(),
      prize_name: prize.label || '',
      prize_code: prize.code  || '',
      patterns:   submittedPicks
    });

    /* Badge & title */
    if (shortEl) shortEl.textContent = prize.short || prize.emoji || '';
    if (titleEl) titleEl.textContent = prize.label || '';
    if (descEl)  descEl.textContent  = '';

    /* Voucher code box */
    if (prize.code && codeEl) {
      codeEl.textContent = prize.code;
      if (codeWrap) codeWrap.classList.remove('hidden');
    } else {
      if (codeWrap) codeWrap.classList.add('hidden');
    }

    /* Copy button */
    if (copyBtn) {
      copyBtn.onclick = function () {
        var text = prize.code || '';
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).catch(function () {});
        }
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
      };
    }

    /* Fine print bullets (prize.desc split by newline) */
    var fineLines = (prize.desc || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    if (finePrintList) {
      finePrintList.innerHTML = fineLines.map(function (l) { return '<li>' + l + '</li>'; }).join('');
    }
    if (finePrint) finePrint.classList.toggle('hidden', fineLines.length === 0);

    /* Email note */
    if (emailNote) {
      if (submittedEmail && prize.code) {
        emailNote.textContent = 'A copy of this code is on its way to ' + submittedEmail;
        emailNote.classList.remove('hidden');
      } else {
        emailNote.classList.add('hidden');
      }
    }

    modal.classList.remove('hidden');
    modal.style.display = 'flex';

    function closeModal() {
      modal.style.display = 'none';
      modal.classList.add('hidden');
    }

    if (closeBtn) closeBtn.onclick = closeModal;
    if (ctaBtn)   ctaBtn.onclick   = function () { window.location.href = '/collections/all'; };

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    launchConfetti();
  }

  /* ────────────────────────────────────────────
     KLAVIYO
  ──────────────────────────────────────────── */
  function kvPost(path, body) {
    if (!KV_KEY) return;
    fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + KV_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status !== 202) {
        res.text().then(function (text) {
          console.warn('PB Vote Klaviyo [' + path + '] → ' + res.status, text);
        });
      }
      return res;
    }).catch(function (err) {
      console.warn('PB Vote Klaviyo fetch error', err);
    });
  }

  function kvSendVoteEvents(email, voteItems) {
    if (!email || !voteItems || voteItems.length === 0) return;
    voteItems.forEach(function (item) {
      kvPost('events', {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Pattern Voted' } } },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    waitlist: 'for-mama',
                    last_voted_collection: item.collectionHandle
                  }
                }
              }
            },
            properties: {
              collection_id:     item.collectionId,
              collection_handle: item.collectionHandle,
              collection_name:   item.collectionName,
              page_url:          location.href,
              source:            'Vote Page - For Mama',
              week:              getWeekId()
            },
            time: new Date().toISOString()
          }
        }
      });
    });
  }

  function kvTrack(eventName, props) {
    if (!submittedEmail) return;
    kvPost('events', {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: eventName } } },
          profile: { data: { type: 'profile', attributes: { email: submittedEmail } } },
          properties: props,
          time: new Date().toISOString()
        }
      }
    });
  }

  function kvSubscribe(email) {
    if (!email || !KV_LIST_ID) return;
    kvPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: { type: 'profile', attributes: { email: email } }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: KV_LIST_ID } }
        }
      }
    });
  }

  /* ────────────────────────────────────────────
     CONFETTI
  ──────────────────────────────────────────── */
  function launchConfetti() {
    var canvas = qs('#pb-confetti-canvas');
    if (!canvas) return;

    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;

    var ctx     = canvas.getContext('2d');
    var colors  = ['#6E5A9E', '#C9B6F0', '#FF6F61', '#F3E3E0', '#322A45', '#EFEAF6'];
    var pieces  = [];

    for (var i = 0; i < 130; i++) {
      pieces.push({
        x:    Math.random() * canvas.width,
        y:    -10 - Math.random() * 60,
        w:    Math.random() * 9 + 4,
        h:    Math.random() * 5 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        vx:   (Math.random() - 0.5) * 3.5,
        vy:   Math.random() * 4 + 1.5,
        rot:  Math.random() * 360,
        vr:   (Math.random() - 0.5) * 9,
        gravity: 0.06
      });
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alive = false;
      pieces.forEach(function (p) {
        if (p.y > canvas.height + 10) return;
        alive = true;
        p.x   += p.vx;
        p.y   += p.vy;
        p.vy  += p.gravity;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rot * Math.PI) / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (alive) requestAnimationFrame(draw);
      else ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    requestAnimationFrame(draw);
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
